import { Box, Button, Flex } from '@chakra-ui/react';
import UserService from 'api/services/UserService';
import InputMy from 'components/InputMy';
import { useFormik } from 'formik';
import _ from 'lodash';
import showMessage from 'providers/NoticeProvider/showMessage';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchMe, selectMe } from 'store/slices/user';
import { editUserInfoValidationSchema } from 'validations';
import ConfirmEmailChangeDialog from './ConfirmEmailChangeDialog';

const MainInfo = () => {
    const dispatch = useAppDispatch();
    const { email, firstName, lastName, id } = useAppSelector(selectMe);
    const [isOpen, setOpen] = useState(false);
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [emailLoading, setEmailLoading] = useState(false);
    const initialValues = { email, firstName, lastName };

    const formik = useFormik({
        initialValues,
        validationSchema: editUserInfoValidationSchema,
        onSubmit: async params => {
            try {
                setLoading(true);
                await UserService.updateById(id, { firstName: params.firstName, lastName: params.lastName })
                    .then(response => {
                        console.log(response);
                        showMessage('Your data has been successfully saved.');
                    })
                    .then(() => {
                        dispatch(fetchMe());
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            } catch (e) {
                return false;
            }
        },
    });

    const disabled = _.isEqual(initialValues, formik.values);

    const handleSubmit = () => {
        if (email !== formik.values.email && !Boolean(formik.errors.email)) {
            setPassword('');
            setOpen(true);
        }
        if (firstName !== formik.values.firstName || lastName !== formik.values.lastName) {
            formik.submitForm();
        }
        // formik.submitForm()
    };

    const handleConfirmEmailChange = async () => {
        try {
            setEmailLoading(true);
            await UserService.updateLogin({
                email: formik.values.email,
                password: password,
            })
                .then(response => {
                    console.log(response);
                    showMessage('Your data has been successfully saved.');
                })
                .then(() => {
                    dispatch(fetchMe());
                })
                .finally(() => {
                    setOpen(false);
                    setEmailLoading(false);
                });
        } catch (e) {
            return false;
        }
    };

    return (
        <Flex flexWrap="wrap" rowGap="24px" columnGap="16px" maxWidth="620px">
            <Box flex={{ sm: '1 0 100%', lg: '1 0 calc(50% - 16px / 2)' }}>
                <InputMy
                    name="firstName"
                    label="First Name"
                    type={'text'}
                    placeholder="First Name"
                    value={formik.values.firstName}
                    onChange={formik.handleChange}
                    error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                    helperText={formik.touched.firstName && formik.errors.firstName}
                    autoComplete="new-password"
                />
            </Box>
            <Box flex={{ sm: '1 0 100%', lg: '1 0 calc(50% - 16px / 2)' }}>
                <InputMy
                    name="lastName"
                    label="Last Name"
                    type={'text'}
                    placeholder="Last Name"
                    value={formik.values.lastName}
                    onChange={formik.handleChange}
                    error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                    helperText={formik.touched.lastName && formik.errors.lastName}
                    onBlur={formik.handleBlur}
                    autoComplete="new-password"
                />
            </Box>
            <Box flex="1 0 100%">
                <InputMy
                    name="email"
                    label="Email"
                    type={'email'}
                    placeholder="Email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                    onBlur={formik.handleBlur}
                    autoComplete="new-password"
                />
            </Box>
            <Flex flex="1 0 100%" gap="8px">
                <Button
                    fontSize="md"
                    variant="brand"
                    fontWeight="600"
                    h="48px"
                    padding="0 24px"
                    onClick={handleSubmit}
                    isDisabled={disabled}
                    isLoading={loading}
                >
                    Save changes
                </Button>
                <Button
                    fontSize="md"
                    variant="outline"
                    fontWeight="600"
                    h="48px"
                    padding="0 24px"
                    onClick={() => formik.resetForm()}
                    isDisabled={disabled || loading}
                >
                    Cancel
                </Button>
            </Flex>
            <ConfirmEmailChangeDialog
                onSubmit={handleConfirmEmailChange}
                open={isOpen}
                setOpen={setOpen}
                password={password}
                setPassword={setPassword}
                loading={emailLoading}
            />
        </Flex>
    );
};

export default MainInfo;
